export default "__VITE_ASSET__BTXx8Mu8__"